import { inject } from '@angular/core';
import { HttpInterceptorFn, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, throwError } from 'rxjs';
import { ToastService } from '../services/toast.service';
import { TranslocoService } from '@jsverse/transloco';

export const http429InterceptorFn: HttpInterceptorFn = (req, next) => {
  const toastService = inject(ToastService);
  const transloco = inject(TranslocoService);

  return next(req).pipe(
    tap(event => {
      if (event instanceof HttpResponse && event.status === 429) {
        showRateLimit(toastService, event.headers, transloco);
      }
    }),
    catchError((error: unknown) => {
      if (error instanceof HttpErrorResponse && error.status === 429) {
        showRateLimit(toastService, error.headers, transloco);
      }
      return throwError(() => error);
    })
  );
};

function showRateLimit(
  toastService: ToastService,
  headers: any,
  transloco: TranslocoService
) {
  const retryAfter = parseInt(headers.get('Retry-After') || '60', 10);
  if (!isNaN(retryAfter) && retryAfter > 0) {
    toastService.showRateLimitCountdown(retryAfter);
  } else {
    const genericMsg = transloco.translate('errors.rateLimitGeneric');
    toastService.show(genericMsg, 'error');
  }
}
